module.exports = __webpack_public_path__ + "img/it.529a7e6a.svg";